import type { InjectionKey } from 'vue'
import type { IDescriptionsInject } from './descriptions.type'

export const descriptionsKey =
  'elDescriptions' as any as InjectionKey<IDescriptionsInject>
